import API from './api.js'

export default {
    async postEvent(data) {
        try {
            let response = await API.HTTPS.post('/events', data)

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },

    async putEvent(id, data) {
        try {
            let response = await API.HTTPS.put('/events/' + id, data)

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },

    async deleteEvent(id, data) {
        try {
            let response = await API.HTTPS.delete('/events/' + id, { data: data })

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    }
}